import Papa from 'papaparse';

import { sheetReader as sheetReaderXLSX } from './sheetReader';

/**
 * A função sheetReader esta espalhada por todo o código e é responsável por ler arquivos CSV e XLSX.
 *  seria importante refatorar essa função para que ela seja mais fácil de manter e entender.
 */
export function sheetReader(file) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    if (file?.type !== 'text/csv') {
      const result = await sheetReaderXLSX(file);

      // Usar Papa Parse para processar corretamente o CSV, incluindo JSONs com vírgulas
      const resultParsed = Papa.parse(result, { skipEmptyLines: true });
      resolve(resultParsed.data);
    } else {
      console.log('Reading CSV file');
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result;
        const result = Papa.parse(text, { skipEmptyLines: true });

        resolve(result.data);
      };
      reader.onerror = reject;
      reader.readAsText(file);
    }
  });
}
